// src/pages/Login.jsx
import "./Login.scss";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";            // ✅ 추가
import { SocketContext } from "../contexts/SocketContext"; // ✅ 추가

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { setUserId } = useContext(SocketContext);

  // 일반 로그인 처리
  const handleLogin = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        { email, password }
      );
      const token = res.data.token;
      localStorage.setItem("token", token);
      setUserId(jwtDecode(token).userId); 
      // 로그인 후 프로필 조회 및 닉네임 분기
      const profile = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/me`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (profile.data.nickname) {
        navigate("/rooms");
      } else {
        navigate("/set-nickname");   // 경로 수정
      }
    } catch (err) {
      setMessage(err.response?.data?.message || "로그인 실패");
    }
  };

  // 네이버 로그인 처리
  const handleNaverLogin = () => {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    const clientId = process.env.REACT_APP_NAVER_CLIENT_ID;
    const state = Math.random().toString(36).substring(2);
    const redirectUri = encodeURIComponent(
      `${BACKEND_HOST}/auth/redirect?state=${state}`
    );
    window.location.href =
      `https://nid.naver.com/oauth2.0/authorize?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&state=${state}` +
      `&scope=profile_email`;
  };

  // 네이버 콜백: 토큰 수신 후 닉네임 분기 로직
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) return;
    (async () => {
      localStorage.setItem("token", token);
      setUserId(jwtDecode(token).userId); 
      try {
        const profile = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (profile.data.nickname) {
          navigate("/rooms");
        } else {
          navigate("/set-nickname");  // 경로 수정
        }
      } catch {
        navigate("/set-nickname");  // 경로 수정
      }
    })();
  }, [navigate]);

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={(e) => e.preventDefault()}>
        <h2>Welcome to Linvesta Lyceum!</h2>
        <p>다시 만나니 너무 반가워요!</p>

        <label>[기수] 이름을 입력해 주세요! ex) [1기] 김재민</label>
        <input
          type="email"
          placeholder="[기수] 이름을 입력해 주세요!"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label>비밀번호</label>
        <input
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {message && <div className="error">{message}</div>}

        <button type="button" onClick={handleLogin}>로그인</button>
        <button type="button" onClick={() => navigate("/register")}>회원가입</button>

        <button
          type="button"
          onClick={handleNaverLogin}
          className="naver-login-btn"
        >
          네이버 로그인
        </button>
      </form>
    </div>
  );
};

export default Login;
